import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'antd';

import TotalValue from '@totem/components/services/remoteAccess/totals/TotalValue';
import RemoteAccessTotalsV2Context from '@totem/components/services/remoteAccess/v2/totals/RemoteAccessTotalsV2Context';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import colors from '@totem/styles/colors';
import { isNotNull } from '@totem/utilities/common';

import './totals.css';

const baseUrl = '/dashboard/remoteAccessUsers';
const TotalsContainer = () => {
  const { totals } = useContext(RemoteAccessTotalsV2Context);
  const { userProfile } = useContext(UserProfileContext);

  const activeAccounts = isNotNull(totals)
    ? totals.total - (totals.neverLoggedIn + totals.stale)
    : 0;

  const userCanSeeRemoteAccess =
    permissions.remoteAccess.hasPermissions(userProfile);

  const styles = {
    borderLeft: {
      borderLeftColor: colors.neutral.silver,
      borderLeftStyle: 'solid' as 'solid',
      borderLeftWidth: 1,
    },
  };

  return (
    <Row>
      <Col span={6}>
        <TotalValue
          title={'Total Accounts'}
          value={
            !userCanSeeRemoteAccess ? (
              <span>{isNotNull(totals) ? totals.total.toString(10) : '0'}</span>
            ) : (
              <Link to={`${baseUrl}`}>
                {isNotNull(totals) ? totals.total.toString(10) : '0'}
              </Link>
            )
          }
        />
      </Col>
      <Col span={6} style={styles.borderLeft}>
        <TotalValue
          title={'Active Accounts'}
          value={
            !userCanSeeRemoteAccess ? (
              <span>{activeAccounts.toString(10)}</span>
            ) : (
              <Link
                to={`${baseUrl}?flags=1`}
                color={colors.event.criticality.background.ok}
              >
                {activeAccounts.toString(10)}
              </Link>
            )
          }
          iconColor={colors.event.criticality.background.ok}
          valueColor={colors.event.criticality.background.ok}
        />
      </Col>
      <Col span={6} style={styles.borderLeft}>
        <TotalValue
          title={'Stale Accounts'}
          value={
            !userCanSeeRemoteAccess ? (
              <span>{isNotNull(totals) ? totals.stale.toString(10) : '0'}</span>
            ) : (
              <Link to={`${baseUrl}?flags=4`}>
                {isNotNull(totals) ? totals.stale.toString(10) : '0'}
              </Link>
            )
          }
          iconColor={colors.event.criticality.background.critical}
          valueColor={colors.event.criticality.background.critical}
        />
      </Col>
      <Col span={6} style={styles.borderLeft}>
        <TotalValue
          title={'Never Used'}
          value={
            !userCanSeeRemoteAccess ? (
              <span>
                {isNotNull(totals) ? totals.neverLoggedIn.toString(10) : '0'}
              </span>
            ) : (
              <Link to={`${baseUrl}?flags=2`}>
                {isNotNull(totals) ? totals.neverLoggedIn.toString(10) : '0'}
              </Link>
            )
          }
          iconColor={colors.event.criticality.background.minor}
          valueColor={colors.event.criticality.background.minor}
        />
      </Col>
    </Row>
  );
};

export default TotalsContainer;
